export default __webpack_public_path__ + "static/media/willow-walk-compass.63befe37.svg";